import type { AssignWorkOrderDraft, WorkOrderAssignmentRow } from "../contract"
import { recommendedWorkOrderCandidates } from "../_shared/_logic/recommendations"

export const defaultAssignWorkOrderDraft = (row: WorkOrderAssignmentRow): AssignWorkOrderDraft => {
  const selectedCandidate = row.workOrderId
    ? (row.candidates.find((entry) => entry.id === row.workOrderId) ?? null)
    : null
  const recommendedCandidates = recommendedWorkOrderCandidates(row)
  const recommendedCandidate =
    row.needsStep !== false && recommendedCandidates.length === 1 ? recommendedCandidates[0] : null
  const candidate = selectedCandidate ?? recommendedCandidate

  return {
    workOrderId: candidate?.id ?? row.workOrderId,
    selectedWorkOrder: candidate?.selection ?? null,
  }
}

export const validateAssignWorkOrderDraft = (
  _row: WorkOrderAssignmentRow,
  draft: AssignWorkOrderDraft,
) => (draft.workOrderId ? null : "Bitte wählen Sie einen Auftrag aus.")
